module.exports = __webpack_public_path__ + "img/icon-differentials2_01.7c11cd41.svg";